﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailBefoerderer extends GuiDetailGeneric {
    constructor() {
        super("Befoerderer");
    }
}
